﻿import {translation} from "@2d-front-monorepo/core";
import {IMvvmContextState, MvvmTextInput} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useMemo} from "react";
import {GlobalConfig} from "../contexts/GlobalContext";
import useEmailRequiredPolicy from "../policies/emailRequiredPolicy";
import usePhoneRequiredPolicy from "../policies/phoneRequiredPolicy";

type Model = {
	email: string;
	familyName: string;
	givenName: string;
	phone: string;
}

type UserDataProps = {
	context: IMvvmContextState<Model>;
	global: GlobalConfig;
};

export default function UserData(props: UserDataProps): JSX.Element {
	const {context, global} = props;
	const phoneData = global.installation.configuration.phoneData;
	const flagImage = `https://flagcdn.com/${phoneData.flag.toLowerCase()}.svg`;

	const givenNameValidation = useMemo(() => ({required: translation(PermitTranslations.validation__given_name__required)}), []);
	const familyNameValidation = useMemo(() => ({required: translation(PermitTranslations.validation__family_name__required)}), []);

	return <>
		<div className="columns gap">
			<MvvmTextInput type="text"
			               context={context}
			               property="givenName"
			               autoComplete="given-name"
			               label={translation(PermitTranslations.given_name)}
			               autoFocus={true}
			               column="col50"
			               validation={givenNameValidation}/>

			<MvvmTextInput type="text"
			               context={context}
			               property="familyName"
			               autoComplete="family-name"
			               label={translation(PermitTranslations.family_mame)}
			               column="col50"
			               validation={familyNameValidation}/>
		</div>

		<MvvmTextInput type="email"
		               context={context}
		               property="email"
		               autoComplete="email"
		               label={translation(PermitTranslations.email)}
		               validation={useEmailRequiredPolicy()}/>

		<MvvmTextInput type="tel"
		               context={context}
		               property="phone"
		               autoComplete="tel-national"
		               label={translation(PermitTranslations.phoneNumber)}
		               column="flex"
		               validation={usePhoneRequiredPolicy(global.installation.countryId)}
		               controlPrefix={
			               <>
				                         <span className="phone-prefix__flag">
					                         <img src={flagImage} width="26" aria-hidden={true} alt=""/>
										 </span>
				               <span>+{phoneData.prefix}</span>
			               </>}
		/>
	</>;
}
